import type { UserRole } from './supabase'

const STORAGE_KEY = 'bsohtak-auth-role'

let cachedUserId: string | null = null
let cachedUserRole: UserRole | null = null

// Hydrate from sessionStorage on module load so a hard refresh (or opening a
// fresh tab) can pick the right sidebar/role immediately, before getCurrentUser
// resolves. sessionStorage is per-tab so it never leaks between users on the
// same machine.
try {
  const raw = sessionStorage.getItem(STORAGE_KEY)
  if (raw) {
    const parsed = JSON.parse(raw) as { id: string; role: UserRole }
    if (parsed?.id && parsed?.role) {
      cachedUserId = parsed.id
      cachedUserRole = parsed.role
    }
  }
} catch {
  /* sessionStorage unavailable — fine */
}

export function getCachedAuth() {
  return { cachedUserId, cachedUserRole }
}

export function setCachedAuth(userId: string, role: UserRole) {
  cachedUserId = userId
  cachedUserRole = role
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ id: userId, role }))
  } catch {
    /* ignore */
  }
}

export function clearAuthRouteCache() {
  cachedUserId = null
  cachedUserRole = null
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    /* ignore */
  }
}
